import { render, staticRenderFns } from "./TheAdminOverview.vue?vue&type=template&id=59875ffa&"
import script from "./TheAdminOverview.vue?vue&type=script&lang=js&"
export * from "./TheAdminOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports